import React, { Component, PropTypes } from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import { Link } from 'react-router';
import moment from 'moment';
import Spinner from './Spinner';
import { toUtc } from '../libs/date';
import DataTable from './DataTable';

@inject('monitoringStore', 'mapStore')
@observer
class Monitoring extends Component {
  static contextTypes = {
    notify: PropTypes.object.isRequired,
  };

  @observable items = [];

  columns = [
    { key: 'sn', label: '#' },
    { key: 'station_identifier', label: 'Station Identifier' },
    { key: 'station_name', label: 'Station Name' },
    { key: 'm', label: '' },
    { key: 'o', label: '' },
    { key: 'data_series', label: 'Data Series' },
    { key: 'error_message', label: <div>Error Message<br />(amount of response)</div> },
    { key: 'last_response', label: 'Latest Response' },
    { key: 'duration', label: 'Duration' },
  ];

  componentWillMount() {
    const { monitoringStore, mapStore } = this.props;
    if (!monitoringStore.isLoading && !monitoringStore.items.length) monitoringStore.fetchItems();

    if (mapStore.stations.length === 0 && !mapStore.loadingMarkers) {
      mapStore.fetchMapMarkers().catch(err => {
        console.log(err);
        this.context.notify.error({ message: 'failed to fetch map markers' })
      })
    }
  }

  getFilteredStations = (items, filteredStations) => {
    if (!filteredStations.length) return items;
    let filteredStationsObj = filteredStations.reduce((acc, item) => {
      if (!acc[item.id]) acc[item.id] = item;
      return acc
    }, {});
    return items.filter(item => !!filteredStationsObj[item.station_id]);
  }

  render() {
    const { monitoringStore, mapStore } = this.props;

    if (monitoringStore.isLoading || mapStore.loadingMarkers) return <Spinner />;

    let filteredItems = this.getFilteredStations(monitoringStore.items, mapStore.filteredStations)
    const data = filteredItems.map((item, index) => ({
      sn: index + 1,
      id: item.station_id,
      station_identifier: item.station_identifier,
      station_name: item.station_name,
      m: <Link to={`/station/${item.station_id}/monitoring`}>M</Link>,
      o: <Link to={`/station/${item.station_id}/observation?${item.series_id ? `series_id=${item.series_id}` : ''}${item.data_series ? `data_series=${item.data_series}` : ''}`}>O</Link>,
      data_series: item.data_series,
      error_message: <div><div>{item.error_message}</div><br /><strong>{item.count}</strong><br /></div>,
      last_response: toUtc(item.time),
      duration: moment.utc(item.time).fromNow(),
    }));

    return (
      <div>
        <DataTable data={data} columns={this.columns} sortRow={items => items.sort((a, b) => a.sn < b.sn ? -1 : 1)} slug='/monitoring/problem' />
        {(!monitoringStore.items || !monitoringStore.items.length) && <div>data not available</div>}
      </div>
    );
  }
}

export default Monitoring;


// WEBPACK FOOTER //
// ./src/components/Monitoring.js